import React from "react";

import { callLink } from "./ChooseProductSection.constants";

export const AutoList = [
  {
    id: 1,
    links: [
      {
        ...callLink,
        description: (
          <>
            <strong>Sinistro:</strong> de segunda a sexta, das 8h às 21h, exceto
            feriados nacionais.
            <br /> <strong>Assistências:</strong> atendimento 24 horas, todos os
            dias da semana, incluindo feriados nacionais.
            <br /> <strong>Serviços e informações:</strong> de domingo a
            domingo, das 9h às 21h, exceto feriados nacionais.
          </>
        ),
        id: "1-link",
      },
    ],
  },
  {
    id: 2,
    links: [
      {
        icon: callLink.icon,
        title: "0800 601 8080",
        id: "2-link",
        href: "tel:0800 601 8080",
        description: (
          <>
            <strong>Renovação</strong>. De segunda a sexta, das 9h às 19h.
          </>
        ),
      },
    ],
  },
];
